import _ from 'lodash';
import React, { useMemo } from 'react';
import { RUN_GRANULARITY } from 'v2/common/constants/index';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { setRootValue } from '../../redux/actions';
import { getSelectorBasedStoreValue } from '../../redux/selector';
import ToggleGroupButton from 'v3/common/components/ToggleGroupButton';

const propTypes = {};
const defaultProps = {};

const GranularitySelector = () => {
  const granularity = useSelector((state) => getSelectorBasedStoreValue(state, 'granularity'));
  const dispatch = useDispatch();
  const onChangeGranularity = (newGranularity) => dispatch(setRootValue({ granularity: newGranularity }));
  const uniqueId = useMemo(() => _.uniqueId('granulatiry_error_'), []);
  const { errors } = useFormContext();
  const errorMessage = _.get(errors, `${uniqueId}.message`, '');
  const isPremiumError = errorMessage.includes('(second by second data)');

  const toggleOptions = [
    {
      value: RUN_GRANULARITY.minute,
      label: 'Minute',
    },
    {
      value: RUN_GRANULARITY.second,
      label: 'Second',
      iconName: isPremiumError ? 'fa-regular fa-indian-rupee-sign' : '',
    },
  ];
  return (
    <div className="run-granularity-container new d-flex flex-column">
      <label className="label_style">
        Historic Candle
      </label>
      <ToggleGroupButton
        options={toggleOptions}
        defaultValue={granularity}
        onChange={onChangeGranularity}
      />
    </div>
  );
};

export default GranularitySelector;

GranularitySelector.propTypes = propTypes;
GranularitySelector.defaultProps = defaultProps;
